module.exports = __webpack_public_path__ + "static/media/ovo-logo-wordmark.c7bfe301.png";